import React, { Component } from "react";
import { Link } from "react-router-dom";
import MedicalConsentHeader from "./MedicalConsentHeader";
import CheckboxInputGroup from "../shared/CheckboxInputGroup";
import TextInput from "../shared/form/TextInput";
import Content from "./../../content/Content";
import Store from "./../../content/Store";
import TextAreaInput from "../shared/form/TextAreaInput";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import { isFieldDefined } from "../../validations/RequiredFieldValidator";
import Button from "../shared/buttons/Button";

export default class ProvideEmergencyConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
      areYouHavingTreatmentHasError: false,
      isTheTreatmentNeededHasError: false,
      doYouHaveOtherPoliciesHasError: false,
      otherInsuranceCompanyAddressHasError: false,
      otherPolicyNumberHasError: false,
      otherInsuranceCompanyNameHasError: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    let errorMessages = this.validate();
    if (errorMessages.length === 0) {
      this.props.provideEmergencyConsentOnSubmit(event);
    } else {
      this.setState({
        errorMessages: errorMessages
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  validate() {
    var localErrorMessages = [];

    let isAreYouHavingTreatmentDefined = isFieldDefined(
      this.props.medicalConsent.areYouHavingTreatment
    );
    let isTheTreatmentNeededDefined = isFieldDefined(
      this.props.medicalConsent.isTheTreatmentNeeded
    );
    let isDoYouHaveOtherPoliceisDefined = isFieldDefined(
      this.props.medicalConsent.doYouHaveOtherPolicies
    );
    let doesHaveOtherPolicy =
      this.props.medicalConsent.doYouHaveOtherPolicies === "yes";
    let isOtherInsuranceCompanyAddressDefined = isFieldDefined(
      this.props.medicalConsent.otherInsuranceCompanyAddress
    );
    let isOtherPolicyNumbertDefined = isFieldDefined(
      this.props.medicalConsent.otherPolicyNumber
    );
    let isOtherInsuranceCompanyNameDefined = isFieldDefined(
      this.props.medicalConsent.otherInsuranceCompanyName
    );

    if (
      !isAreYouHavingTreatmentDefined ||
      !isTheTreatmentNeededDefined ||
      !isDoYouHaveOtherPoliceisDefined
    ) {
      localErrorMessages.push(
        Store.MedicalConsent.ValidationErrors.AllFieldsRequired
      );
    }

    let shouldAddErrorForOtherPolicyInput =
      this.props.medicalConsent.doYouHaveOtherPolicies === "yes" &&
      (isAreYouHavingTreatmentDefined ||
        isTheTreatmentNeededDefined ||
        isDoYouHaveOtherPoliceisDefined);

    if (
      shouldAddErrorForOtherPolicyInput &&
      (!isOtherInsuranceCompanyAddressDefined ||
        !isOtherPolicyNumbertDefined ||
        !isOtherInsuranceCompanyNameDefined)
    ) {
      localErrorMessages.push(
        Store.MedicalConsent.ValidationErrors.AllFieldsRequired
      );
    }

    this.setState({
      areYouHavingTreatmentHasError: !isAreYouHavingTreatmentDefined,
      isTheTreatmentNeededHasError: !isTheTreatmentNeededDefined,
      doYouHaveOtherPoliciesHasError: !isDoYouHaveOtherPoliceisDefined,
      otherInsuranceCompanyAddressHasError:
        doesHaveOtherPolicy && !isOtherInsuranceCompanyAddressDefined,
      otherPolicyNumberHasError:
        doesHaveOtherPolicy && !isOtherPolicyNumbertDefined,
      otherInsuranceCompanyNameHasError:
        doesHaveOtherPolicy && !isOtherInsuranceCompanyNameDefined
    });

    return localErrorMessages;
  }

  render() {
    return (
      <div>
        <MedicalConsentHeader
          pageTitle={this.props.pageTitle}
          pageBody={this.props.pageBody}
        />

        <DisplayValidationErrors
          heading={this.props.errorValidationHeading}
          errors={this.state.errorMessages}
        />

        <form onSubmit={event => this.onSubmit(event)}>
          <CheckboxInputGroup
            hasError={this.state.areYouHavingTreatmentHasError}
            inputValue={this.props.medicalConsent.areYouHavingTreatment}
            groupName="areYouHavingTreatment"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={Store.MedicalConsent.ProvideEmergencyConsentGroupLabelOne}
              />
            }
          />
          <CheckboxInputGroup
            hasError={this.state.isTheTreatmentNeededHasError}
            inputValue={this.props.medicalConsent.isTheTreatmentNeeded}
            groupName="isTheTreatmentNeeded"
            onChange={this.props.onChange}
            groupDetails={
              <Content
                name={
                  Store.MedicalConsent.ProvideEmergencyConsentGroupTwoDetails
                }
              />
            }
            groupHeader={
              <Content
                name={Store.MedicalConsent.ProvideEmergencyConsentGroupLabelTwo}
              />
            }
          />
          <CheckboxInputGroup
            hasError={this.state.doYouHaveOtherPoliciesHasError}
            inputValue={this.props.medicalConsent.doYouHaveOtherPolicies}
            groupName="doYouHaveOtherPolicies"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={
                  Store.MedicalConsent.ProvideEmergencyConsentGroupLabelThree
                }
              />
            }
          />
          <div
            id="otherPolicyDetailsSection"
            className={
              this.props.medicalConsent.doYouHaveOtherPolicies === "no" ||
              !this.props.medicalConsent.doYouHaveOtherPolicies
                ? "d-none"
                : ""
            }
          >
            <TextInput
              hasError={this.state.otherInsuranceCompanyNameHasError}
              inputId="otherInsuranceCompanyName"
              inputValue={this.props.medicalConsent.otherInsuranceCompanyName}
              onChange={this.props.onChange}
              autoComplete="off"
              label={
                <Content
                  name={
                    Store.MedicalConsent.ProvideEmergencyConsentTextInputOne
                  }
                />
              }
            />
            <TextAreaInput
              hasError={this.state.otherInsuranceCompanyAddressHasError}
              inputId="otherInsuranceCompanyAddress"
              fieldName="otherInsuranceCompanyAddress"
              inputValue={
                this.props.medicalConsent.otherInsuranceCompanyAddress
              }
              rows="5"
              onChange={this.props.onChange}
              label={
                <Content
                  name={
                    Store.MedicalConsent.ProvideEmergencyConsentTextInputTwo
                  }
                />
              }
            />
            <TextInput
              hasError={this.state.otherPolicyNumberHasError}
              inputId="otherPolicyNumber"
              inputValue={this.props.medicalConsent.otherPolicyNumber}
              onChange={this.props.onChange}
              autoComplete="off"
              label={
                <Content
                  name={
                    Store.MedicalConsent.ProvideEmergencyConsentTextInputThree
                  }
                />
              }
            />
          </div>
          <div className="row my-5">
            <div className="col-sm-6 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link
                  id="backButton"
                  to=""
                  onClick={event =>
                    this.props.previousContentHandleBackClick(event)
                  }
                >
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.buttonBackText}
                </Link>
              </p>
            </div>
            <div className="col-sm-6 text-right" id="provideEmergencyConsentSubmitButton">
              <Button label={this.props.nextButton} />
            </div>
          </div>
        </form>
      </div>
    );
  }
}
